<template>
	<div class="home main">
		<van-sticky>
			<div class="search-wrap">
				<img class="icon-search" src="@static/images/business/icon_search.png" alt="">
				<van-search v-model="searchParams.nickname" @input='search' placeholder="搜索访客微信昵称">
				</van-search>
			</div>
		</van-sticky>
		<van-loading v-if="isSearch && searchParams.nickname" size="24px" vertical>搜索中...</van-loading>
		<van-pull-refresh v-if="list.length" v-model="refreshing" @refresh="onReferesh">
			<van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="nextPage">
				<div v-for="(customer, idx) in list" :key="idx" class="list" @click="goDetail(customer)">
					<div class="visitor-box">
						<div class="customer f">
							<img class="img-head" :src="customer.imgUrl" alt="">
							<div class="content f-col">
								<span class="ok-spancolor" v-html="customer.nameHTML">{{customer.nickname}}</span>
								<span>{{ customer.createTime | formatTime('MM-DD HH:mm') }}</span>
							</div>
							<span v-if="customer.time" class="time">阅读{{ customer.time }}</span>
						</div>
						<div class="info">
							查看了{{ VISIT_TYPE[customer.type] }}《{{ customer.name }}》</div>
						<span v-if="customer.customerId" class="tip">客户</span>
					</div>
				</div>
			</van-list>
		</van-pull-refresh>
		<div v-else-if="list.length == 0 && searchParams.nickname && !isSearch" class="empty-box">
			<img src="@static/images/business/empty_2.png" alt="">
			<p>暂无搜索结果</p>
		</div>
	</div>
</template>
<script>
var time;
import {
	loading,
	common
} from "@/api/mixins";
import filter from "@/api/filter";
export default {
	name: 'apps.business.searchVisitor',
	mixins: [loading, common],
	data() {
		return {
			value: '',
			list: [],
			isSearch: false,
			refreshing: false, //下拉刷新
			finished: true, //是否完成上拉加载
			searchParams: { //列表查询参数
				type: '', //访问类型 字典 key VISIT_TYPE 获取
				tabType: 3, //apptab栏类型,@notes1-按访客展示2-按内容展示 3根据人去重展示最新
				pageSize: 10,
				pageNo: 1,
				nickname: ''
			},
			VISIT_TYPE: {}
		};
	},
	created() {
		//查字典 获取tabs
		this.getDicByType({
			type: "VISIT_TYPE"
		}).then(res => {
			this.VISIT_TYPE = res;
			this.tabs = [{
				val: '全部',
				key: ''
			}]
			for (let key in res) {
				this.tabs.push({
					val: res[key],
					key
				})
			}
		})
		// this.getList(false);
	},
	methods: {
		goDetail(item) {
			this.$router.push({
				path: '/apps/business/visitorDetail',
				query: {
					visitorId: item.visitorId,
					type: item.type
				}
			})
		},
		search(val) {
			this.isSearch = true;
			clearTimeout(time);
			time = setTimeout(() => {
				this.getList(false);
			}, 1000)
		},
		//上拉加{载
		nextPage() {
			if (this.searchParams.pageNo == this.totalNo) {
				this.finished = true;
				return;
			}
			this.searchParams.pageNo++;
			this.getList(false)
		},
		hightLight(keyWord, suggtion) {
			// 使用 regexp 构造函数，因为这里要匹配的是一个变量
			const reg = new RegExp(keyWord, 'ig')
			const newSrt = String(suggtion).replace(reg, function (p) {
				return '<span style="color: #236DFF">' + p + '</span>'
			})
			return newSrt
		},
		//下拉刷新
		onReferesh() {
			this.refreshing = true;
			this.searchParams.pageNo = 1;
			this.getList(false);
		},
		getList(loading = true) {
			if (!this.searchParams.nickname) {
				this.list = []
				return;
			}
			this.loading = loading;
			this.$http({
				type: "POST",
				url: "/app/visitRecord/list",
				data: this.searchParams
			}).then(res => {
				console.log(res);
				this.searchParams.pageNo = res.current;
				this.totalNo = res.pages;
				if (res.current == 1) {
					this.list = [];
				}
				res.data = res.data.map(item => {
					if (this.searchParams.nickname) {
						item.nameHTML = this.hightLight(this.searchParams.nickname, item.nickname)
					} else {
						item.nameHTML = item.nickname;
					}
					return item;
				})
				this.list = [...this.list, ...res.data].map(item => {
					if (item.visitTime) {
						item.time = this.$tools.formatSeconds(item.visitTime)
					}

					return item
				});
				console.log(this.list)
				this.isSearch = false;
				this.refreshing = false;
				this.loading = false;
				if (res.current === res.pages) {
					this.finished = true;
				} else {
					this.finished = false;
				}
			}).catch(() => {
				this.isSearch = false;
				this.loading = false;
				this.refreshing = false;
				this.finished = true;
			})
		}
	},
	components: {},
};
</script>

<style lang="scss" scoped>
/deep/.van-loading {
	padding-top: 60px;
}

/deep/.search-wrap {
	background-color: #fff;

	.van-search {
		padding: 20px 30px;
	}

	.van-search__content {
		width: 690px;
		height: 66px;
		background: rgba(243, 243, 243, 0.39);
		border-radius: 8px;
		line-height: 66px;
		padding-left: 64px;
	}

	.icon-search {
		width: 24px;
		position: absolute;
		left: 50px;
		top: 40px;
	}

	.van-field__left-icon {
		display: none;
	}
}

.empty-box {
	text-align: center;

	img {
		margin-top: 286px;
		width: 420px;
		height: 180px;
	}

	p {
		text-align: center;
		margin-top: 40px;
		font-size: 28px;
		line-height: 40px;
		color: #727C8E;
	}
}

.main {
	min-height: 100vh;
	background-color: #F5F7FA;
	display: flex;
	flex-direction: column;
}

.header {
	display: flex;
	padding: 30px;
	align-items: center;
	justify-content: space-between;

	.icon-search {
		width: 35px;
		height: 35px;
	}

	.title {
		flex: 1;
		font-size: 34px;
		font-weight: 600;
		line-height: 48px;
		color: #13233F;
	}

	/deep/.van-tabs__wrap {
		flex: 0 0 320px;
		width: 320px;

		.van-tabs__nav--card {
			margin: 0;
			border-radius: 3px;
		}
	}

	/deep/.van-tabs .van-tab--active .van-tab__text {
		font-size: 26px;
		color: #FFFFFF;
		// padding: 0 15px;
	}

	/deep/.van-tabs .van-tab__text {
		font-size: 26px;
		color: #515A6E;
	}
}

/deep/.van-pull-refresh {
	flex: 1;
}

.sub-header {
	padding: 0 4px;

	/deep/.van-tabs {
		border-bottom: none;

		.van-tabs__nav {
			background-color: transparent;
		}
	}

	/deep/.van-tabs .van-tab--active .van-tab__text {
		font-size: 30px;
		font-weight: 600;
		color: #17233D;
	}

	/deep/.van-tab {
		margin: 0 23px;
	}

	/deep/.van-tabs .van-tab__text {
		font-size: 30px;
		color: #515A6E;
	}
}

.list {
	.visitor-box {
		width: 690px;
		// height: 220px;
		background: rgba(255, 255, 255, 1);
		border-radius: 10px;
		margin: 20px auto;
		position: relative;
		padding-bottom: 20px;

		.customer {
			padding: 26px 32px 26px 28px;

			.img-head {
				flex: 0 0 86px;
				width: 86px;
				height: 86px;
				border-radius: 50%;
				margin-right: 14px;
				border-radius: 50%;
			}

			.content {
				flex: 1;

				&> :first-child {
					font-size: 30px;
					line-height: 42px;
					color: #17233D;
				}

				&> :last-child {
					font-size: 26px;
					line-height: 31px;
					color: #8E96A5;
					margin-top: 10px;
				}
			}

			.time {
				font-size: 26px;
				line-height: 31px;
				color: #727C8E;
				margin-right: 1px;
			}
		}

		.info {
			font-size: 28px;
			line-height: 40px;
			max-height: 100px;
			color: #17233D;
			padding: 20px 30px 0px;
			border-top: 1px solid #ECECEC;
			display: -webkit-box;
			-webkit-box-orient: vertical;
			-webkit-line-clamp: 2;
			overflow: hidden;
		}

		.tip {
			position: absolute;
			width: 80px;
			height: 40px;
			background: linear-gradient(135deg, #23AAFF 0%, #2378FF 100%);
			opacity: 1;
			border-radius: 0px 10px 0px 10px;
			font-size: 24px;
			line-height: 40px;
			color: #FFFFFF;
			text-align: center;
			right: 0;
			top: 0;
		}
	}
}

.customer-record-box {
	display: flex;
	border-bottom: 1px solid #DFE5ED;
	padding: 30px 0;
	margin: 0 30px;

	.cover {
		position: relative;
		text-align: center;
		width: 150px;
		height: 150px;
		background: #FFFFFF;
		border-radius: 10px;
		overflow: hidden;
		margin-right: 20px;

		.icon {
			width: 50px;
			margin-top: 20px;
		}

		.cover-img {
			width: 100%;
		}

		.name {
			position: absolute;
			left: 0;
			right: 0;
			bottom: 0;
			width: 150px;
			height: 42px;
			background: #E7EFFD;

			font-size: 24px;
			line-height: 42px;
			text-align: center;
			color: #2E4F96;



		}
	}

	.content {
		height: 150px;
		display: flex;
		flex-direction: column;

		.info {
			flex: 0 0 80px;
			width: 520px;
			font-size: 30px;
			line-height: 40px;
			color: #17233D;
			overflow: hidden;
			text-overflow: ellipsis;
			display: -webkit-box;
			-webkit-box-orient: vertical;
			-webkit-line-clamp: 2;

		}

		.time-wrap {
			margin-top: 10px;
			font-size: 26px;
			line-height: 40px;
			color: #727C8E;
			margin-top: 28px;

			img {
				width: 40px;
				height: 40px;
				border-radius: 50%;
				margin-right: 8px;
			}
		}
	}
}

.f {
	display: flex;
	align-items: center;
}

.f-b {
	display: flex;
	justify-content: space-between;
	align-items: center;
}

.f-col {
	display: flex;
	flex-direction: column;
	justify-content: center;
}

.f-c {
	display: flex;
	align-items: center;
	justify-content: center;
}

*[blue] {
	color: #236DFF;
}
</style>
